import produce from "immer";
import {
  GET_ATTRIBUTE_CUSTOMIZATION_REQUEST,
  GET_ATTRIBUTE_CUSTOMIZATION_SUCCESS,
  GET_ATTRIBUTE_CUSTOMIZATION_ERROR,
  CREATE_ATTRIBUTE_CUSTOMIZATION_REQUEST,
  CREATE_ATTRIBUTE_CUSTOMIZATION_SUCCESS,
  CREATE_ATTRIBUTE_CUSTOMIZATION_ERROR,
  UPDATE_ATTRIBUTE_CUSTOMIZATION_REQUEST,
  UPDATE_ATTRIBUTE_CUSTOMIZATION_SUCCESS,
  UPDATE_ATTRIBUTE_CUSTOMIZATION_ERROR,
  DELETE_ATTRIBUTE_CUSTOMIZATION_REQUEST,
  DELETE_ATTRIBUTE_CUSTOMIZATION_SUCCESS,
  DELETE_ATTRIBUTE_CUSTOMIZATION_ERROR,
  REORDER_ATTRIBUTE_CUSTOMIZATION_REQUEST,
  REORDER_ATTRIBUTE_CUSTOMIZATION_SUCCESS,
  REORDER_ATTRIBUTE_CUSTOMIZATION_ERROR,
  FETCH_PROJECT_ATTRIBUTE_VALUES_PORTFOLIO_SUCCESS,
  FETCH_SCENARIO_ATTRIBUTE_VALUES_PORTFOLIO_SUCCESS,
} from "../types";

const initialState = {
  project_attributes: [],
  scenario_attributes: [],
  // project_id (string key, since JSON map keys are strings) → AttributeValueDTO[]
  project_values_map: {},
  // scenario_id → AttributeValueDTO[]
  scenario_values_map: {},
  isFetching: false,
  isUpdating: false,
  error: null,
};

const targetKey = (target) =>
  target === "SCENARIO" ? "scenario_attributes" : "project_attributes";

const upsertInList = (list, dto) => {
  const next = list.slice();
  const idx = next.findIndex((a) => a.id === dto.id);
  if (idx >= 0) next[idx] = dto;
  else next.push(dto);
  return next;
};

export default function attributeCustomizationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ATTRIBUTE_CUSTOMIZATION_REQUEST:
      return produce(state, (d) => {
        d.isFetching = true;
        d.error = null;
      });
    case GET_ATTRIBUTE_CUSTOMIZATION_SUCCESS:
    case REORDER_ATTRIBUTE_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isFetching = false;
        d.isUpdating = false;
        d.project_attributes = Array.isArray(action.payload.project_attributes)
          ? action.payload.project_attributes
          : [];
        d.scenario_attributes = Array.isArray(action.payload.scenario_attributes)
          ? action.payload.scenario_attributes
          : [];
      });
    case GET_ATTRIBUTE_CUSTOMIZATION_ERROR:
      return produce(state, (d) => {
        d.isFetching = false;
        d.error = action.payload;
      });
    case CREATE_ATTRIBUTE_CUSTOMIZATION_REQUEST:
    case UPDATE_ATTRIBUTE_CUSTOMIZATION_REQUEST:
    case DELETE_ATTRIBUTE_CUSTOMIZATION_REQUEST:
    case REORDER_ATTRIBUTE_CUSTOMIZATION_REQUEST:
      return produce(state, (d) => {
        d.isUpdating = true;
        d.error = null;
      });
    case CREATE_ATTRIBUTE_CUSTOMIZATION_SUCCESS:
    case UPDATE_ATTRIBUTE_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        const key = targetKey(action.payload.target);
        d[key] = upsertInList(d[key], action.payload);
      });
    case DELETE_ATTRIBUTE_CUSTOMIZATION_SUCCESS:
      return produce(state, (d) => {
        d.isUpdating = false;
        const { id, target } = action.payload;
        const key = targetKey(target);
        d[key] = d[key].filter((a) => a.id !== id);
      });
    case CREATE_ATTRIBUTE_CUSTOMIZATION_ERROR:
    case UPDATE_ATTRIBUTE_CUSTOMIZATION_ERROR:
    case DELETE_ATTRIBUTE_CUSTOMIZATION_ERROR:
    case REORDER_ATTRIBUTE_CUSTOMIZATION_ERROR:
      return produce(state, (d) => {
        d.isUpdating = false;
        d.error = action.payload;
      });
    case FETCH_PROJECT_ATTRIBUTE_VALUES_PORTFOLIO_SUCCESS:
      return produce(state, (d) => {
        d.project_values_map = action.payload || {};
      });
    case FETCH_SCENARIO_ATTRIBUTE_VALUES_PORTFOLIO_SUCCESS:
      return produce(state, (d) => {
        d.scenario_values_map = action.payload || {};
      });
    default:
      return state;
  }
}
